import React, { useEffect } from "react";
import { Box, Center, Heading, Stack } from "@chakra-ui/layout";
import { useNavigate } from "react-router";
import { Button } from "@chakra-ui/button/";
import { Image } from "@chakra-ui/react";

export const FailedPaymentPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => navigate("/"), 5000);
  }, [navigate]);

  return (
    <Box height="100vh">
      <Box
        width="full"
        height="full"
        bgColor="white"
        borderStyle="dashed"
        borderWidth="thick"
      >
        <Center h="full">
          <Stack spacing={8}>
            <Stack alignItems="center">
              <Heading>Payment Failed</Heading>
              <Image src="/images/error.gif" alt="Payment Failed" />
            </Stack>
            <Center>
              <Button
                backgroundColor={"gray.900"}
                color={"white"}
                width={48}
                _hover={{
                  backgroundColor: "gray.500"
                }}
                onClick={() => {
                  navigate("/");
                }}
              >
                Return to home
              </Button>
            </Center>
          </Stack>
        </Center>
      </Box>
    </Box>
  );
};
